<!--
    Dispatches the availability text (DELIVERY_DATE/E3917B experiment,
    resolveDeliveryText, stripLieferbarPrefix). Does not deal with OttoUp - that
    building block is independent and always rendered by the caller.

    Note: this intentionally does not depend on DeliveryDispatcher, which is
    slated for removal; the pure delivery-text helpers are reused directly
    instead.
-->
<script lang="ts">
    import type { Availability } from '@shared/types/types.ts';
    import AvailabilityComponent from '@tile/components/availability/Availability.svelte';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import { resolveDeliveryText } from '@tilelist/layouts/dispatchers/delivery-dispatcher/resolveDeliveryText.ts';
    import { stripLieferbarPrefix } from '@tilelist/layouts/dispatchers/delivery-dispatcher/stripLieferbarPrefix.ts';

    interface Props {
        availability: Availability | undefined;
        showAvailability: boolean;
    }

    let { availability, showAvailability }: Props = $props();

    const onex = injectWiring().onex;
    const deliveryDateExperimentActive = $derived(onex.isExperimentGroup('DELIVERY_DATE', 'E3917B'));
    const deliveryText = $derived(
        stripLieferbarPrefix(resolveDeliveryText(availability, deliveryDateExperimentActive)),
    );
</script>

{#if showAvailability}
    <AvailabilityComponent text={deliveryText} />
{/if}
